<template>
  <v-layout row justify-center v-if="!isFetchingSlide">
    <v-dialog v-model="dialog" persistent max-width="500px">
      
      <v-card>
        <v-card-title>
          <span class="headline">Edit Slide</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field label="Content" v-model="content" required></v-text-field>
              </v-flex>
           
            </v-layout>
          </v-container>
          
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="dialog = false">{{translater.__('Close')}}</v-btn>
          <v-btn color="blue darken-1" :disabled="!valid" flat @click.native="updateSlide()">{{translater.__('Save')}}</v-btn>
        </v-card-actions>
      </v-card>
      <!--v-card v-else>Loading</v-card-->
    </v-dialog>
  </v-layout>
</template>

<script>
  export default {
    name: 'EditSlide',
    data()
    {
      return {
        content: ''
      }
    },

    created()
    {
      
    },

    mounted()
    {
      this.$nextTick(() => {
        
        if(typeof this.editableSlide !== 'undefined')
        {
         
          this.content = this.editableSlide.content
          this.$store.commit('checkpoints/setIsFetchingSlide', false)
          
        } else {
          
        }
      })
    },

    methods: {
      updateSlide()
      {
        this.$store.dispatch('checkpoints/updateSlide', this.content)
        this.dialog = false
      }
    },

    computed: {
      dialog: {
        get()
        {
          return this.$store.getters['checkpoints/isEditingSlide'];
        },

        set(value)
        {
          this.$store.dispatch('checkpoints/setIsEditingSlide', value)
        }
      },

      isFetchingSlide: {
        get()
        {
          return this.$store.getters['checkpoints/isFetchingSlide'];
        },

        set(value)
        {
          this.$store.commit('checkpoints/setIsFetchingSlide', value)
        }
      },

      editableSlide: {
        get()
        {
          return this.$store.getters['checkpoints/editableSlide']
        }
      },

      valid: {
        get()
        {
          return this.content.trim() !== '';
        }
      },

      translater: {
        get()
        {
          return this.$store.getters['translate/translater'];
        }
      }


      
    }
  }
</script>